<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">     
      
      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
          <el-form-item style="width:18%">
          	  <el-date-picker v-model="query.date" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" :unlink-panels="false" style="width:100%" @change="ischange=true"></el-date-picker>
          </el-form-item>
          <el-form-item style="width:12%" v-if="$cookies.get('agentid')==36">
		        <el-select v-model="query.datafrom" clearable remote  filterable placeholder="请选择订单来源" @change="ischange=true">
	          	  <el-option v-for="(item,index) in datafromlists" :label="item.name" :value="item.id" :key="index"></el-option>
	          </el-select>      
	        </el-form-item>
          <el-form-item style="width:12%" v-if="$cookies.get('agentid')==36">
		      <el-select v-model="query.paytype" clearable remote  filterable placeholder="请选择支付类型" @change="ischange=true">
	          	  <el-option v-for="(item,index) in paytypelists" :label="item.name" :value="item.id" :key="index"></el-option>
	          </el-select>      
	      </el-form-item>
          <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="getlists">查询</el-button>
              <el-button type="success" icon="el-icon-download" @click="exportdata" v-if="$cookies.get('agentid')==36">导出</el-button>
          </el-form-item>
      </el-form>
      
      <!-- 信息提示 -->
      <!--
      <div class="datawarning" :style="maxheight">
          <span class="dtitle">数据说明：</span>
          <span class="dcontent">
              <p>1、此处统计的订单数据为：a、线上支付已付款的订单；b、线下支付的订单。（注：统计的订单信息有可能已发货，有可能未发货）；</p>
              <p>2、此处统计的销售总额（总）为实际订单支付金额，销售总额（京东）为京东商品销售小计、销售总额（宠赞）为宠赞商品销售小计；</p>
              <p>3、销售总额（总）有可能不等于销售总额（京东）+销售总额（宠赞），因销售的订单中有可能使用代金券，有可能有品牌活动；</p>
              <p>4、统计的数据里有些订单有可能未发货，所以销售成本（总）、销售成本（京东）、销售成本（宠赞）有可能为0或变动；</p>
              <p>5、订单是否发货取决于线下销售出库单状态是否为已完成；</p>
          </span>
          <a @click="sacnotice"><img src="../../assets/position.png" /></a>
      </div>
      -->
      
      <!-- 统计 -->
      <div class="alls">
          <div class="allssingle" style="background:#409EFF">
             <span style="float:left;padding:.3rem .7rem;background:#fff;color:#409EFF;border-radius:50%;font-size:.9rem;font-weight:bold">Al</span>
             <div style="float:left;width:60%;transition:all .5s">
                <span style="float:left;width:95%;font-size:.9rem;color:#fff;margin-left:5%;font-weight:bold;line-height:1.3rem">￥{{allsaleslists.sales}}</span>
                <span style="float:left;width:95%;font-size:.7rem;color:#fff;margin-left:5%;line-height:1.3rem">总销售额</span>
             </div>
          </div>
          <div class="allssingle" style="background:#F56C6C" v-if="$cookies.get('agentid')==36">
             <span style="float:left;padding:.3rem .7rem;background:#fff;color:#F56C6C;border-radius:50%;font-size:.9rem;font-weight:bold">JD</span>
             <div style="float:left;width:60%;transition:all .5s">
                <span style="float:left;width:95%;font-size:.9rem;color:#fff;margin-left:5%;font-weight:bold;line-height:1.3rem">￥{{allsaleslists.jdsales}}</span>
                <span style="float:left;width:95%;font-size:.7rem;color:#fff;margin-left:5.5%;line-height:1.3rem">京东销售额</span>
             </div>
          </div>
          <div class="allssingle" style="background:#67C23A" v-if="$cookies.get('agentid')==36">
             <span style="float:left;padding:.3rem .7rem;background:#fff;color:#67C23A;border-radius:50%;font-size:.9rem;font-weight:bold">CZ</span>
             <div style="float:left;width:60%;transition:all .5s">
                <span style="float:left;width:95%;font-size:.9rem;color:#fff;margin-left:5%;font-weight:bold;line-height:1.3rem">￥{{allsaleslists.czsales}}</span>
                <span style="float:left;width:95%;font-size:.7rem;color:#fff;margin-left:5.5%;line-height:1.3rem">宠赞销售额</span>
             </div>
          </div>
      </div>

      <div class="backborder2">
	      <el-table :data="lists" v-loading="listsloading">
            <el-table-column prop="time" label="时间" align="left"></el-table-column>
            <el-table-column prop="numbers" label="订单数" align="center" width="100"></el-table-column>
            <el-table-column prop="allsales" label="销售总额" align="center" width="100"></el-table-column>
            <el-table-column prop="allcost" label="销售成本" align="center" width="100" v-if="$cookies.get('agentid')==36"></el-table-column>
            <el-table-column prop="allprofit" label="销售利润" align="center" width="100" v-if="$cookies.get('agentid')==36"></el-table-column>
            <el-table-column prop="jdsales" label="销售总额（京东）" align="center" width="100" v-if="$cookies.get('agentid')==36"></el-table-column>
            <el-table-column prop="jdcost" label="销售成本（京东）" align="center" width="100" v-if="$cookies.get('agentid')==36"></el-table-column>
            <el-table-column prop="jdprofit" label="销售利润（京东）" align="center" width="100" v-if="$cookies.get('agentid')==36"></el-table-column>
            <el-table-column prop="czsales" label="销售总额（宠赞）" align="center" width="100" v-if="$cookies.get('agentid')==36"></el-table-column>
            <el-table-column prop="czcost" label="销售成本（宠赞）" align="center" width="100" v-if="$cookies.get('agentid')==36"></el-table-column>
            <el-table-column prop="czprofit" label="销售利润（宠赞）" align="center" width="100" v-if="$cookies.get('agentid')==36"></el-table-column>
            <el-table-column label="操作" align="center" width="100">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" icon="el-icon-search" circle @click="getdetailorders(scope.row)"></el-button>
                </template>
            </el-table-column>
          </el-table>
          <div class="block">
	          <!--分页begin-->
	          <el-pagination
	            @size-change="MallstatpageChange"
	            @current-change="MallstatpageCurrentChange"
	            :current-page="query.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="query.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="rows">
	          </el-pagination>
	          <!--分页end-->
          </div>
      </div>
      
      <!-- 导出信息确认 -->
      <el-dialog title="导出销售统计信息确认" :visible.sync="exportDialog" width="90%" top="5vh">
	      	<el-button size="medium" type="danger" @click="customeroutput" style="float:right;margin-right:0;margin-bottom:15px">确认导出</el-button>
	      	<div id="outputorder">
		      	<el-table :data="exportlists" border v-loading="exportLoading">
		      	  	<el-table-column prop="time" label="时间" align="left"></el-table-column>
                    <el-table-column prop="numbers" label="订单数" align="center" width="100"></el-table-column>
                    <el-table-column prop="allsales" label="销售总额（总）" align="center" width="100"></el-table-column>
                    <el-table-column prop="allcost" label="销售成本（总）" align="center" width="100"></el-table-column>
                    <el-table-column prop="allprofit" label="销售利润（总）" align="center" width="100"></el-table-column>
                    <el-table-column prop="jdsales" label="销售总额（京东）" align="center" width="100"></el-table-column>
                    <el-table-column prop="jdcost" label="销售成本（京东）" align="center" width="100"></el-table-column>
                    <el-table-column prop="jdprofit" label="销售利润（京东）" align="center" width="100"></el-table-column>
                    <el-table-column prop="czsales" label="销售总额（宠赞）" align="center" width="100"></el-table-column>
                    <el-table-column prop="czcost" label="销售成本（宠赞）" align="center" width="100"></el-table-column>
                    <el-table-column prop="czprofit" label="销售利润（宠赞）" align="center" width="100"></el-table-column>
		      	</el-table>
	      	</div>
	      	<div slot="footer" class="dialog-footer">
		        <el-button size="medium" @click="exportDialog=false">取 消</el-button>
		        <el-button size="medium" type="danger" @click="customeroutput">确认导出</el-button>
		    </div>	                
	    </el-dialog>

        <!-- 销售信息详情 -->
        <el-dialog title="信息详情" :visible.sync="orderdetailDialog" width="90%" top="5vh">
            <div style="float:left;width:100%;margin-bottom:20px;">
                <div v-if="mallnums > 0" style="float:left;width:96%;border-radius:5px;background:rgb(211, 211, 211, .7);padding:1rem 2%;">
                    <span style="float:left;width:100%;font-size:.8rem;color:#606266;font-weight:bold;margin-bottom:10px">线上商城订单信息</span>
                    <el-table :data="detailsales.mall" v-loading="orderdetailLoading">
                        <el-table-column type="expand">
                        <template slot-scope="props">
                            <el-table :data="props.row.goods">
                                <el-table-column prop="productname" label="商品名称"></el-table-column>
                                <el-table-column prop="propertyname" label="规格" ></el-table-column>
                                <el-table-column prop="price" label="价格" align="center"></el-table-column>
                                <el-table-column prop="numbers" label="数量" align="center"></el-table-column>
                                <el-table-column prop="total" label="小计" align="center"></el-table-column>
                                <el-table-column prop="type" label="商品类型" align="center" v-if="$cookies.get('agentid')==36"></el-table-column>
                            </el-table>
                        </template>
                        </el-table-column>
		                <el-table-column label="订单编号" prop="ordernumbers"></el-table-column>
                        <el-table-column label="店铺名称" prop="shopname"></el-table-column>
                        <el-table-column label="订单金额" prop="total" align="center"></el-table-column>
                        <el-table-column label="支付金额" prop="prices" align="center"></el-table-column>
                        <el-table-column label="下单时间" prop="inputtime" align="center"></el-table-column>
	      	        </el-table>
                </div>

                <div v-if="splitnums > 0" style="float:left;width:96%;margin-top:20px;border-radius:5px;background:rgb(211, 211, 211, .7);padding:1rem 2%;">
                    <span style="float:left;width:100%;font-size:.8rem;color:#606266;font-weight:bold;margin-bottom:10px">分销订单信息</span>
                    <el-table :data="detailsales.split" v-loading="orderdetailLoading">
                        <el-table-column type="expand">
                        <template slot-scope="props">
                            <el-table :data="props.row.goods">
                                <el-table-column prop="productname" label="商品名称"></el-table-column>
                                <el-table-column prop="propertyname" label="规格"></el-table-column>
                                <el-table-column prop="price" label="价格" align="center"></el-table-column>
                                <el-table-column prop="numbers" label="数量" align="center"></el-table-column>
                                <el-table-column prop="total" label="小计" align="center"></el-table-column>
                                <el-table-column prop="type" label="类型" width="80" align="center"></el-table-column>
                            </el-table>
                        </template>
                        </el-table-column>
		                <el-table-column label="订单编号" prop="ordernumbers"></el-table-column>
                        <el-table-column label="店铺名称" prop="shopname"></el-table-column>
                        <el-table-column label="订单金额" prop="total" align="center"></el-table-column>
                        <el-table-column label="支付金额" prop="prices" align="center"></el-table-column>
                        <el-table-column label="下单时间" prop="inputtime" align="center"></el-table-column>
	      	        </el-table>
                </div>

            </div>
            <div slot="footer" class="dialog-footer">
		        <el-button size="medium" @click="orderdetailDialog=false">取 消</el-button>
		    </div>	 
        </el-dialog>

  </div>
  </transition> 
</template>

<script>

export default {
  data () {
    return {
      url:this.GLOBAL.domain+"Mallstat/index",
      transitionshow:true,
      query: {
          act:'ordersaleslists',
          token:this.$cookies.get('token'),
          date:[new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate(),new Date().getFullYear().toString() + '-' + (new Date().getMonth()+1) + '-' + new Date().getDate()],
          datafrom:'',
          paytype:'',
          ispay:'',
          isexport:0,
          p:1,
          rollpage:10
      },
      datafromlists:[{id:1,name:'商城订单'},{id:2,name:'分销订单'}],
      paytypelists:[{id:1,name:'线上支付'},{id:2,name:'线下支付'}],
      paylists:[{id:1,name:'已支付'},{id:2,name:'未支付'}],
      ischange:false,
      listsloading:false,
      lists:[],
      rows:0,
      maxheight: {'max-height':'1.5rem'},
      exportDialog:false,
      exportLoading:false,
      exportlists:[],
      exporthead:[],
      exportfield:[],
      exportname:'',
      allsaleslists:[],
      detailsales:[],
      orderdetailDialog:false,
      orderdetailLoading:false,
      mallnums:0,
      splitnums:0,

    }  
  },
  mounted(){
     this.getlists(); //获取销售信息列表
  },
  methods:{

      /** 获取统计的销售信息 **/
      getsaleslists() {
          var resource = this.$resource(this.url);
          resource.save({act:'salestotal',token:this.$cookies.get('token'),date:this.query.date,datafrom:this.query.datafrom,paytype:this.query.paytype,ispay:this.query.ispay}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
              }else{
                  this.allsaleslists = JSON.parse(Base64.decode(res.data.Data));
              }
          }).catch((res) => {
              
          });
      },

      /** 展开、隐藏提示信息 **/
      sacnotice() {
          if(this.maxheight['max-height']=='1.5rem') {
              this.maxheight['max-height']='8rem';
          }else {
              this.maxheight['max-height']='1.5rem';
          }
      },

      /** 获取销售信息 **/
      getlists() {
          if(this.ischange==true) {this.query.p=1;this.query.rollpage=10;}
          this.listsloading=true;
          var resource = this.$resource(this.url);
          this.query.isexport=0;
          resource.save(this.query).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.listsloading=false;
              }else{
                  this.lists = JSON.parse(Base64.decode(res.data.Data));
	              this.rows=parseInt(res.data.count);
                  if(this.ischange==true) this.ischange=false;
                  this.listsloading=false;
                  this.getsaleslists();
              }
          }).catch((res) => {
              this.listsloading=false;
          });
      },

      MallstatpageChange(val) {
        this.query.rollpage = val;
        this.getlists();
      },
      MallstatpageCurrentChange(val) {
        this.query.p = val;
        this.getlists();
      },

      /** 导出统计数据 **/
      exportdata() {
          this.exportDialog=true;
          this.exportLoading=true;
          var resource = this.$resource(this.GLOBAL.exportUrl+"Mallstat/index");
          this.query.isexport=1;
          resource.save(this.query).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.exportLoading=false;
              }else{
                  this.exportlists = JSON.parse(Base64.decode(res.data.Data));
                  this.exportLoading=false;
              }
          }).catch((res) => {
              this.exportLoading=false;
          });
      },

      //按客户导出销售数据
      customeroutput() {
    	  this.exporthead=['时间','订单数','销售总额（总）','销售成本（总）','销售利润（总）','销售总额（京东）','销售成本（京东）','销售利润（京东）','销售总额（宠赞）','销售成本（宠赞）','销售利润（宠赞）'];
	      this.exportfield=['time','numbers','allsales','allcost','allprofit','jdsales','jdcost','jdprofit','czsales','czcost','czprofit'];
	      this.exportname='线上销售统计报表';
	      this.exportput();
	      this.exportDialog=false;		
      },

      /** 确认导出信息 **/
      exportput() {
		  require.ensure([], () => {
			  var { export_json_to_excel } = require('../../vendor/Export2Excel');
			  var data = this.formatJson(this.exportfield, this.exportlists);
			  export_json_to_excel(this.exporthead, data, this.exportname);
		  })
      },
    
      //导出表格数据
	  formatJson(filterVal, jsonData) {
　　　　  return jsonData.map(v => filterVal.map(j => v[j]));
　　  },


      /** 获取销售信息详情 **/
      getdetailorders(item) {
          this.orderdetailDialog=true;
          this.orderdetailLoading=true;
          var resource = this.$resource(this.url);
          resource.save({act:'getsalesinfos',token:this.$cookies.get('token'),date:item.time,datafrom:this.query.datafrom,paytype:this.query.paytype,ispay:this.query.ispay}).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.orderdetailLoading=false;
              }else{
                  this.detailsales = JSON.parse(Base64.decode(res.data.Data));
                  this.mallnums=this.detailsales.mall.length;
                  this.splitnums=this.detailsales.split.length;
                  this.orderdetailLoading=false;
              }
          }).catch((res) => {
              this.orderdetailLoading=false;
          });
      },


  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 1% 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.datawarning {border-radius:5px;width:96%;padding:.3rem 2% .3rem 2%;margin-top:10px;background:rgb(221,221,221,.7);border:1px solid rgb(221,221,221,.9);min-height:1rem;overflow:hidden;transition: all .8s}
.dtitle {float:left;line-height:1.5rem;font-size:.7rem;color:red}
.dcontent {float:left;width:60%;margin-left:1%;}
.dcontent p {float:left;margin:0;width:100%;line-height:1.5rem;font-size:.7rem;color:red}
.datawarning a {cursor:pointer;float:left;margin-left:2%;width:1.5rem;height:1.5rem;background:#67C23A;border-radius:50%;transition: all .8s}
.datawarning a img{float:left;width:.6rem;margin-left:.45rem;margin-top:.45rem}
.alls {width:100%;padding:10px 0 10px 0;min-height:3.5rem;}
.allssingle {float:left;margin-right:1%;background:#fff;border-radius:5px;border:1px solid #ddd;padding:.5rem;}
</style>


// WEBPACK FOOTER //
// src/components/mall/Mallsalestat.vue